import { Directive, ElementRef, Input } from '@angular/core';

@Directive({ selector: '[sm-center]' })
export class SalonMonsterTextCenterDirective {
    constructor(el: ElementRef) {
       el.nativeElement.style['text-align'] = 'center';
    }
}